import { BeButton, BePage, BeStack, BeTextControl } from "@beos-css/react/index.ts";

export function KeyLinesDemo() {
	return (
		<section id="demo-page-keylines">
			<h2>Key lines</h2>
			<p>
				Controls reserve margin for whatever their shadow reaches — 1px for a button&rsquo;s frame, 5px for the default button&rsquo;s outer
				ring, 0 for a text field. Because <code>gap</code> sits between margin boxes, that reserve is what makes the <em>visible</em> edges
				line up and the visible spacing uniform: measured, ink edges at 8/8/8 and ink gaps of 8/8, against border edges of 8/9/13. Align the
				border boxes instead and the ring lands 5px out of true.
			</p>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="item" align="start">
					<BeTextControl defaultValue="a text field" />
					<BeButton>A button</BeButton>
					<BeButton variant="default">A default button</BeButton>
				</BeStack>
			</BePage>
		</section>
	);
}
